import React from 'react'
import { Datagrid, TextField, useTranslate, DateField, List, FunctionField } from 'react-admin'
import { FormattedTextFieldWithStatus } from '../sales/reservation/helper/FormattedTextFieldWithStatus'
import { iconAccordingProduct } from '../sales/reservation/helper/IconAccordingProduct'

function LastSalesList() {
  const translate = useTranslate()

  return (
    <List
      component='div'
      hasCreate={false}
      exporter={false}
      pagination={false}
      actions={null}
      resource='reservation'
      perPage={15}
      filter={{ optional_get_creator: true }}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <Datagrid bulkActionButtons={false} rowClick='show'>
        <TextField label={translate('ra.field.reservation_number')} source='number' sortable={false} />
        <FunctionField
          label={translate('ra.field.product')}
          render={(record) => iconAccordingProduct(record.items)}
        />
        <TextField label={translate('ra.field.seller')} source='user' sortable={false} />
        <TextField label={translate('ra.field.passenger')} source='passenger' sortable={false} />

        <DateField label={translate('ra.field.date_first_service')} source='date_in' sortable={false} />
        <TextField label={translate('ra.field.user')} source='creator' sortable={false} />
        <DateField label={translate('ra.field.created_at')} source='create_at' sortable={false} />
        <FormattedTextFieldWithStatus label={translate('ra.field.status')} source='status' sortable={false} />
      </Datagrid>
    </List>
  )
}

export default LastSalesList
